import React from 'react'
import DeleteInstaIntent from './deleteInstaIntent'
interface IProps {
  intent: any
  closeModal: () => void
  inputJson: any[]
  setInputJson: React.Dispatch<React.SetStateAction<any[]>>
  data: any
}

const DeleteInstaIntentModal: React.FC<IProps> = ({
  inputJson,
  setInputJson,
  intent,
  closeModal,
  data
}) => {
  return (
    <div className='card w-530px h-180px '>
      <div className='d-flex justify-content-between mx-0 px-0 mb-2'>
        <span className='mb-2 me-auto'></span>
      </div>
      <DeleteInstaIntent
        inputJson={inputJson}
        setInputJson={setInputJson}
        intent={intent}
        closeModal={closeModal}
        data={data}
      />
    </div>
  )
}

export default DeleteInstaIntentModal
